<template>
  <div
    class="fts-radio-group"
    :class="[
      {'radio-group--dir-h': horizontal},
      {'comfort-design': comfortDesign}
    ]"
  >
    <div class="radio-group-container">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    horizontal: Boolean,
    comfortDesign: Boolean,
  }
}
</script>

<style lang="scss" scoped>
@import "./src/assets/scss/vars.scss";

.fts-radio-group {
  display: inline-flex;
  &.radio-group--dir-h {
    .radio-group-container {
      @include flex-gap($display: flex, $gap: 0.75rem);
    }
  }
  &:not(.radio-group--dir-h) {
    .radio-group-container {
      display: flex;
      flex-direction: column;
      > *:not(:last-child) {
        margin-bottom: 0.5rem;
      }
    }
  }
  &.comfort-design {
    &:not(.radio-group--dir-h) {
      .radio-group-container {
        > *:not(:last-child) {
          margin-bottom: 1rem;
        }
      }
    }
  }
}
</style>